module.exports = __webpack_public_path__ + "img/apple-store-badge.2928664f.svg";